import { toast } from 'react-toastify';

export const global_error_handler = (errors: any) => {
  console.log('ERROR', errors);
  console.log('ERROR', errors.response);

  if (errors === undefined) {
    toast.error('Проблемы с интернет соединением', {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  } else {
    if (errors.response?.status === 400) {
      if (Array.isArray(errors.response.data)) {
        const textError = errors.response.data.join(', ');
        toast.error(textError, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        /* for (let i = 0; i < errors.response.data.length; i++) {

                    setTimeout(() => {
                        toast.error(errors.response?.data[i], {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }, 200 * (i + 1))
                } */
      } else {
        toast.error('Что-то пошло не так, обратитесь в техподдержку', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } else if (errors.response?.status === 401) {
      window.location.hash = 'logout-auth';
      toast.error('NOAUTORIZE', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else if (errors.response?.status === 403) {
      toast.error('Недостаточно прав!', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else {
      toast.error('Что-то пошло не так, обратитесь в техподдержку', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }
};
